import React, { useState,useEffect } from 'react';
import { Container, TextField, Button, Box, Typography, Link, Grid, IconButton, InputAdornment } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { USER_LOGIN } from '../graphql/mutations';
import { useMutation } from '@apollo/client';
import { useAuth } from '../AuthContext'; // Import the useAuth hook


const Root = styled('div')(({ theme }) => ({
  height: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'black',
  padding: '0',

  [theme.breakpoints.up('sm')]: {
    padding: '0',
  },
}));

const FormContainer = styled(Box)(({ theme }) => ({
  // boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  backgroundColor: '#fff',
  width: '100%',
  maxWidth: '380px',
  border: '4px solid #F04A60',

  [theme.breakpoints.up('sm')]: {
    padding: '2rem',
    maxWidth: '400px',
  },
}));

const InputField = styled(TextField)(({ theme }) => ({
  marginBottom: '1rem',
  backgroundColor: '#fff',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    width: '90%',  // For extra-small screens
    marginLeft: '20px',
  },
  [theme.breakpoints.up('sm')]: {
    marginLeft: '0px',  // For small and larger screens
  },
}));
const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#000',
  color: '#fff',
  padding: '12px',
  '&:hover': {
    backgroundColor: '#333',
  },
  width: '100%', // Default to full width

  [theme.breakpoints.down('sm')]: {
    width: '90%', // For extra-small screens
    marginLeft: '20px',
  },
  [theme.breakpoints.up('sm')]: {
    width: '100%', // Full width for small and larger screens
    marginLeft: '0px',
  },
}));

const LogoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: '1.5rem',

  [theme.breakpoints.up('sm')]: {
    marginTop: '2rem',
  },
}));

const logoSrc = '/images/AE_SoftwareLogo_AECHECK_Drk.png';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const { login } = useAuth();

  const [loginUser] = useMutation(USER_LOGIN);
  const [isUsernameFilled, setIsUsernameFilled] = useState(false);
  const [isPasswordFilled, setIsPasswordFilled] = useState(false);

  useEffect(() => {
    // Check if fields are already filled on component mount (e.g., from autofill)
    setIsUsernameFilled(Boolean(username));
    setIsPasswordFilled(Boolean(password));
  }, [username, password]);

  const handleLogin = async () => {
    try {
      const { data } = await loginUser({ variables: { username, password } });
      localStorage.setItem('token', data.aeCheckUserLogin);
      localStorage.setItem('username', username);
      login(); // Update auth state
      navigate('/dropdownpage'); // Navigate to DropdownPage
    } catch (err) {
      setError('Invalid username or password');
      console.error('Login failed:', err);
    }
  };

  return (
    <Root>
      <Container maxWidth="xs"  >
        <FormContainer>
          <Typography variant="h5" sx={{

            textAlign: 'center',
            // Center the text
          }} gutterBottom marginTop={"20px"}>
            Welcome to AeCheck
          </Typography>

          {error && (
            <Typography variant="body2" color="error" align="center" gutterBottom>
              {error}
            </Typography>
          )}

          <InputField
            fullWidth
            label="Username"
            variant="outlined"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            InputLabelProps={{
              shrink: true, // Keeps label in shrunk position
            }}
          />

          <InputField
            fullWidth
            label="Password"
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              shrink: true, // Keeps label in shrunk position
            }}
          />


          <StyledButton
            fullWidth
            variant="contained"
            size="large"
            onClick={handleLogin}
          >
            Sign in
          </StyledButton>

          <Grid container justifyContent="center" style={{ marginTop: '1rem' }}>
            <Grid item>
              <Typography variant="body2">
                Issues logging in? Contact AeLive <Link href="mailto:Aether.Requests@ae.live">here</Link>
              </Typography>
            </Grid>
          </Grid>

          <LogoBox>
            <Box
              component="img"
              src={logoSrc}
              alt="logo"
              sx={{
                width: '120px',
                height: 'auto',
              }}
            />
          </LogoBox>
        </FormContainer>
      </Container>
    </Root>
  );
};

export default Login;